module.exports = __webpack_public_path__ + "img/hiperme_isologotipo_miscelanias.8acb86d3.svg";